import { render, staticRenderFns } from "./ClientPayout.vue?vue&type=template&id=4051e178&"
import script from "./ClientPayout.vue?vue&type=script&lang=js&"
export * from "./ClientPayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports